<template>
  <div class="notification-item-component">
    <div class="item-avatar">
      <ym-avatar class="user-avatar"
                 :avatar="item.user.avatar"
                 size="small"
      />
    </div>
    <div class="item-info">
      <div class="item-header">
        <span class="name">{{ item.user.name }}</span>
        <span class="date">{{ item.createdTime|formatMessageTime }}</span>
      </div>
      <div class="item-message"
           v-html="item.message"
      ></div>
      <div class="item-action"
           v-if="showAction"
           @click="handleNotificationDetail"
      >
        点击前往>>
      </div>
    </div>
  </div>
</template>

<script>
  import { locationHref, getProductPath, projectJump } from '@/utils/index';
  import Avatar from '@/components/Avatar';

  export default {
    name: 'NotificationItem',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
    computed: {
      showAction() {
        if (this.item.action) return true;
        return false;
      },
    },
    methods: {
      handleNotificationDetail() {
        if (this.item.action.type === 'web') {
          locationHref(this.item.action.url);
        } else {
          const route = getProductPath(this.item.action.type, this.item.action.id);
          projectJump(route);
        }
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .notification-item-component {
    display: flex;
    padding-bottom: @size-base;
    position: relative;
    &:not(:last-child) {
      margin-bottom: @size-base;
    }
    &:after {
      position: absolute;
      content: '';
      width: 720px;
      height: 1px;
      background: @background-color-base;
      left: 0;
      bottom: 0;
    }
  }

  .item-avatar {
    margin-right: @size-small;
  }

  .item-info {
    flex: 1;
  }

  .item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: @size-small;
    .name {
      color: @color-text-light;
      font-size: @font-size-medium;
      font-weight: @font-weight-primary;
    }
    .date {
      color: @color-text-lighter;
      font-size: @font-size-small;
    }
  }

  .item-message {
    color: @color-text-base;
    font-size: @font-size-base;
    /deep/ img {
      margin: @size-small 0;
      border-radius: @border-radius-normal;
    }
  }

  .item-action {
    margin-top: @size-small;
    color: @color-primary;
    font-size: @font-size-base;
  }
</style>
